import {registerPlugin} from '@capacitor/core';

export type IntentListener = 'appUrlOpen' | 'imageReceived' | 'fileReceived' | 'nultipleFilesRecived';
export interface IntentResult {
    url?: string;
    imageUri?: string;
    fileUri?: string;
    fileUris?: string;
}

export interface IntentHandlerPlugin {
    addListener(event: IntentListener, callback: any): Promise<IntentResult>;
}
const cmIntentHandler = registerPlugin<IntentHandlerPlugin>('CMIntentHandler');
export default cmIntentHandler;
